import React from "react";

interface ClockProps {
  size: number;
  color?: string;
}

export default function Clock({ size = 20, color = "#79808A" }: ClockProps) {
  return (
    <div>
      <svg
        width={size}
        height={size}
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 14.7619H10.2V9.33333H12V14.7619ZM13.8 3H8.4V4.80952H13.8V3ZM4.8 13.8571C4.80016 12.3097 5.36424 10.816 6.38562 9.65834C7.40699 8.50067 8.81487 7.75929 10.3431 7.57435C11.8713 7.38941 13.414 7.77374 14.6795 8.65466C15.945 9.53559 16.8456 10.8521 17.211 12.3552L17.751 11.8124C18.039 11.5229 18.39 11.3329 18.75 11.2333C18.4595 10.3426 18.0113 9.51194 17.427 8.78143L18.705 7.49667C18.3 7.03524 17.895 6.61905 17.436 6.22095L16.158 7.52381C14.763 6.38381 13.008 5.71429 11.1 5.71429C8.95175 5.71429 6.89148 6.57219 5.37243 8.09927C3.85339 9.62636 3 11.6975 3 13.8571C3 18.0462 6.15 21.4933 10.2 21.9457V20.1181C7.149 19.6748 4.8 17.051 4.8 13.8571ZM12 20.1543V22H13.836L19.353 16.4629L17.517 14.6081L12 20.1543ZM20.865 14.2824L19.677 13.0881C19.497 12.9071 19.2 12.9071 19.029 13.0881L18.147 13.9748L19.983 15.8205L20.865 14.9338C21.045 14.7619 21.045 14.4633 20.865 14.2824Z"
          fill={color}
        />
      </svg>
    </div>
  );
}
